import axios from "axios";
import permissions from "./permissions";
import server from "./server";
import translator from "./translator";
import Vue from 'vue';
export default {
    data: new Vue({
        data(){
            return {
                courses: null,
                user: null,
                courses_anonym: null,
                user_anonym: null
            };
        }
    }),
    mounted(next) {
        let token = localStorage.getItem('jwt_customer');
        let baseUrl = "api/public/check?lang=";
        if (!token) {
            token = localStorage.getItem('jwt_company');
            baseUrl = "api/public/company/check?lang="
        }
        axios.defaults.headers.common['Content-Type'] = 'application/json';
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        server.get(baseUrl + translator.getCurrent()).then((r) => {
            if (r.data.status !== 0) {
                token = false;
            } else {
                for (var i in r.data.data) {
                    this.data[i] = r.data.data[i];
                }
            }
        }).catch(() => {
            token = false;
        }).then(() => {
            if (!token) {
                this.data = {};
                this.logout();
                return false;
            } else {
                permissions.init();
                next();
                return true;
            }
        });

    },
    logout() {
        localStorage.setItem('jwt_customer', "");
        localStorage.setItem('jwt_company', "");
        axios.defaults.headers.common['Authorization'] = '';
        window.location.href = "/login.html";
    },
    mountedAnonym(next) {
        let token = localStorage.getItem('jwt_anonym_customer');
        axios.defaults.headers.common['Content-Type'] = 'application/json';
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;

        server.get("api/public/anonym/check").then((r) => {
            if (r.data.status !== 0) {
                token = false;
            } else {
                for (var i in r.data.data) {
                    this.data[i] = r.data.data[i];
                }
            }
        }).catch(() => {
            token = false;
        }).then(() => {
            if (!token) {
                this.data = {};
                this.logoutAnonym();
                return false;
            } else {
                permissions.init();
                next();
                return true;
            }
        });

    },
    logoutAnonym() {
        localStorage.setItem('jwt_anonym_customer', "");
        axios.defaults.headers.common['Authorization'] = '';
        window.location.href = "/anonym/login.html";
    },
    isCompany(){
        return !!localStorage.getItem('jwt_company')
    }
};




// WEBPACK FOOTER //
// ./src/public_app/api/login.js